export type JourneyEvent = {
  year: number
  title: string
  description: string
  images: {
    src: string
    caption: string
  }[]
}

export const startYear = 2019
export const currentYear = new Date().getFullYear()

// Placeholder image pool — replace with real photos per year as they become available
const samplePhotos = [
  'https://cdn.magicpatterns.com/uploads/mHVgw9s4dvc7ZNg4SyCCbX/IMG-20260510-WA0027.jpg',
  'https://cdn.magicpatterns.com/uploads/f1R2Vny6zLJmaijCMSyGae/IMG-20260510-WA0031.jpg',
  'https://cdn.magicpatterns.com/uploads/kZrAiEzTqMexLKrw7mfDaQ/IMG-20260510-WA0028.jpg',
  'https://cdn.magicpatterns.com/uploads/9LCvC9itFaKE48VpCiXSmL/IMG-20260510-WA0026.jpg',
]

export const journey: JourneyEvent[] = [
  {
    year: 2019,
    title: 'The Beginning',
    description:
      'Camp David Prayer Platform was born — a small gathering of believers united by a hunger for the presence of God.',
    images: [
      { src: samplePhotos[0], caption: 'Our very first gathering' },
      { src: samplePhotos[1], caption: 'Early morning prayers' },
      { src: samplePhotos[2], caption: 'A hunger for His presence' },
    ],
  },
  {
    year: 2020,
    title: 'Growing in Faith',
    description:
      'Through the global pandemic, we held fast in prayer — online vigils carried us and our community through uncertainty.',
    images: [
      { src: samplePhotos[2], caption: 'Virtual prayer vigils' },
      { src: samplePhotos[3], caption: 'Community in lockdown' },
      { src: samplePhotos[0], caption: 'Holding fast in prayer' },
    ],
  },
  {
    year: 2021,
    title: 'Expanding Our Reach',
    description:
      'Reopening with renewed fire — outreaches resumed and new programs were birthed to serve the community.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/rv1HyRyAzteGefUqnYTmES/LDG_APRIL_B_2021.jpg',
        caption: 'Last Day Gathering — April 2021',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/mZ2bFiiR9qHPtAfUhfVgA6/Hospital_Outreach_photo2_28th_February_2021.jpg',
        caption: 'Hospital Outreach — February 2021',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/jkdf48DHFpfoUMSLn3Qv9N/Orphanage_Outreach_May_2021_A_(1).jpg',
        caption: 'Orphanage Outreach — May 2021',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/rQYzkmMbQA1tVtfeViPZaW/Orphanage_Outreach_May_2021_G.jpg',
        caption: 'Orphanage Outreach — May 2021',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/owYsCmYaP2VoQQ9q23enNc/Last_Day_Gathering_January_2021.jpg',
        caption: 'Last Day Gathering — January 2021',
      },
    ],
  },
  {
    year: 2022,
    title: 'NIWALE is Born',
    description:
      'The Night Watchers Legislation began — gathering intercessors monthly to stand in the gap for our nation.',
    images: [
      { src: samplePhotos[3], caption: 'First NIWALE prayer night' },
      { src: samplePhotos[0], caption: 'Watchmen on the wall' },
      { src: samplePhotos[1], caption: 'Standing in the gap' },
    ],
  },
  {
    year: 2023,
    title: 'Hands That Heal',
    description:
      'Hospital outreaches at Christ Medical and Zimran — bringing prayer, comfort, and tangible help to the sick.',
    images: [
      { src: samplePhotos[1], caption: 'Christ Medical Center outreach' },
      { src: samplePhotos[2], caption: 'Praying with patients' },
      { src: samplePhotos[3], caption: 'Zimran Medical visit' },
    ],
  },
  {
    year: 2024,
    title: 'Christ Love at Christmas',
    description:
      'Visiting Ajebor Orphanage and other homes — sharing love, gifts, and the message of Christ at Christmas.',
    images: [
      { src: samplePhotos[0], caption: 'Ajebor Orphanage Christmas' },
      { src: samplePhotos[1], caption: 'Gifts of love' },
      { src: samplePhotos[2], caption: 'Christmas joy shared' },
    ],
  },
  {
    year: 2025,
    title: 'A Wider Mission Field',
    description:
      'New campuses, new partnerships, deeper impact — Camp David spreads beyond Benin City.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/vkDXZDQg7dvwozg54jYYQx/Correctional_Center_Outreach.jpg',
        caption: 'CCO 2025 — The Gospel of the Kingdom',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/nEuBSwSbwn3A542wFAB76w/Hospital_Outreach.jpg',
        caption: 'Hospital Outreach — March 2025, Christ Medical Center',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/g9dWR75XeKkNRPfzQmuCam/IMG_20250531_130837_349.jpg',
        caption: 'Orphanage Outreach — Kinglucy Orphanage Home',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/fiE12BJZ55CCWrWnWdQvVz/Orphanage_Outreach(1).jpg',
        caption: 'Orphanage Outreach — Kinglucy Orphanage Home',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/eDAzJqovYCz11ofrzhk1mM/Orphanage_Outreach.jpg',
        caption: 'Christ Love at Christmas — Orphanage Outreach',
      },
    ],
  },
  {
    year: 2026,
    title: 'The Journey Continues',
    description:
      'A new year, a new chapter — pressing forward in prayer, outreach, and unwavering faith.',
    images: [
      {
        src: 'https://cdn.magicpatterns.com/uploads/ijXcxNDUmirTMzvTCExJwZ/Market_Outreach.jpg',
        caption: 'Market Outreach 2026',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/9gb3dyZoWpSLxwuto3ZMvn/Hospital_Outreach_(1).jpg',
        caption: 'Hospital Outreach — Zimran Medical Centre, Benin City',
      },
      {
        src: 'https://cdn.magicpatterns.com/uploads/eugH9WvNSEBrDamRh1F7vU/Hospital_Outreach_.jpg',
        caption: 'Hospital Outreach — Zimran Medical Centre, Benin City',
      },
    ],
  },
].filter((e) => e.year >= startYear && e.year <= currentYear)
